const mediaItems = [
  {
    id: 1,
    title: '明星塌房全纪录：从被拍到实锤，完整时间线梳理',
    duration: '15:32',
    views: '1280万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20video%20thumbnail%20style%20image%20with%20warm%20orange%20glow%2C%20play%20button%20overlay%2C%20celebrity%20news%20documentary%20feel%2C%20editorial%20photography%2C%20high%20contrast%2C%20modern%20YouTube%20thumbnail%20aesthetic&width=560&height=320&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '网红夫妻离婚大战：双方放出对方出轨证据合集',
    duration: '22:08',
    views: '960万',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20dramatic%20confrontation%20video%20thumbnail%2C%20dark%20moody%20atmosphere%20with%20warm%20crimson%20accents%2C%20couple%20conflict%20theme%2C%20editorial%20style%2C%20high%20contrast%20lighting%2C%20modern%20thumbnail%20design&width=560&height=320&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '选秀节目黑幕曝光：导师评分内幕大揭秘',
    duration: '18:45',
    views: '890万',
    image: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlight%20and%20dark%20shadows%2C%20mysterious%20atmosphere%2C%20warm%20golden%20lighting%2C%20video%20thumbnail%20style%2C%20editorial%20photography%2C%20high%20contrast&width=560&height=320&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '直播带货翻车现场：名场面一次看个够',
    duration: '12:20',
    views: '750万',
    image: 'https://readdy.ai/api/search-image?query=Livestream%20studio%20with%20dramatic%20red%20and%20orange%20lighting%2C%20chaotic%20atmosphere%2C%20dark%20background%2C%20video%20thumbnail%20style%2C%20modern%20influencer%20aesthetic%2C%20high%20energy%20composition&width=560&height=320&seq=media-04&orientation=landscape',
  },
  {
    id: 5,
    title: '电竞圈年度大瓜：冠军战队内部分裂全解析',
    duration: '20:15',
    views: '680万',
    image: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20dramatic%20dark%20lighting%2C%20warm%20orange%20and%20amber%20glow%2C%20competitive%20gaming%20atmosphere%2C%20video%20thumbnail%20style%2C%20editorial%20photography%2C%20high%20contrast%20dramatic%20mood&width=560&height=320&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            视频吃瓜
          </h2>
          <p className="text-sm text-foreground-500 mt-2">热门吃瓜视频精选，图文不过瘾？来看视频版</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 transition-all duration-300 hover:border-accent-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-accent-500/90 flex items-center justify-center group-hover:bg-accent-500 group-hover:scale-110 transition-all duration-200 shadow-lg">
                    <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 backdrop-blur-sm rounded text-[10px] text-white">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500/90 rounded text-[10px] text-white flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-heading font-bold text-foreground-950 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}